import { ModalProps } from "antd/lib/modal/Modal";
import { Input, Modal } from "antd";
import Style from "./index.module.scss";
import React, { useImperativeHandle, useState } from "react";
import Form, { useForm } from "rc-field-form";
import FieldWithError from "../../../../../FieldWithError";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: (sourceName: string, id: number) => void;
}

interface FormProp {
    sourceName: string;
}
const ReNameModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, ...props }, ref) => {
        const [form] = useForm<FormProp>();

        async function onFinish(data: FormProp) {
            onSuccess(data.sourceName, defaultData.id);
        }

        const [defaultData, setDefaultData] = useState({
            sourceName: "",
            id: -1
        });
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setDefaultData(payload);
            }
        }));

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                maskClosable={false}
                title="课件重命名"
                onOk={form.submit}>
                <div className={Style.root}>
                    <Form form={form} onFinish={onFinish}>
                        <FieldWithError
                            name="sourceName"
                            initialValue={defaultData.sourceName}>
                            <Input />
                        </FieldWithError>
                    </Form>
                </div>
            </Modal>
        );
    }
);

export default ReNameModal;
